import { Radio, RadioGroup } from '@billy/design-system'
import { ChangeEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceTotalPriceColumns } from '@features/invoices/enums/invoiceTotalPriceColumns'
import { getInvoiceTotalPriceColumns } from '@features/invoices/utils/getInvoiceTotalPriceColumns'
import { isInvoiceTotalPriceColumns } from '@features/invoices/utils/isInvoiceTotalPriceColumns'
import { replaceInvoiceTotalPriceColumns } from '@features/invoices/utils/replaceInvoiceTotalPriceColumns'

import { useWatch } from '../../../../../../../../../../../../../../../../hooks'
import { useInvoiceColumnVisibilitySettingsForm } from '../../../../../../../../../../../../contexts/invoiceColumnVisibilityFormContext'
import { useInvoiceEditorForm } from '../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { useInvoiceLineHeaderLabels } from '../../../../../../../../hooks/useInvoiceLineHeaderLabels'
import { InvoiceColumnsVisibilitySettingsSection } from '../InvoiceColumnsVisibilitySettingsSection'

export const TotalPriceColumnsSettings = () => {
  const { t } = useTranslation()
  const { getHeaderLabel } = useInvoiceLineHeaderLabels()
  const { invoiceLinesColumnsVisibilityForm, isLoading } = useInvoiceColumnVisibilitySettingsForm()
  const { control, setValue } = invoiceLinesColumnsVisibilityForm
  const { trackInvoiceEditor } = useInvoiceEditorForm()

  const visibleColumns = useWatch({ control, name: 'selectedColumns' })

  const value = getInvoiceTotalPriceColumns(visibleColumns)

  const handleTotalPriceRadioClick = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const totalPriceColumns = event?.target?.value

      if (!isInvoiceTotalPriceColumns(totalPriceColumns)) {
        return
      }

      const selectedColumns = replaceInvoiceTotalPriceColumns(visibleColumns, totalPriceColumns)
      setValue('selectedColumns', selectedColumns, { shouldDirty: true })
      trackInvoiceEditor('Column visibility changed', { selectedColumns })
    },
    [setValue, visibleColumns, trackInvoiceEditor],
  )

  return (
    <RadioGroup disabled={isLoading} onChange={handleTotalPriceRadioClick} value={value}>
      <InvoiceColumnsVisibilitySettingsSection>
        <Radio value={InvoiceTotalPriceColumns.Net}>{getHeaderLabel('netTotal')}</Radio>
        <Radio value={InvoiceTotalPriceColumns.Gross}>{getHeaderLabel('total')}</Radio>
        <Radio value={InvoiceTotalPriceColumns.Both}>
          {t('external_invoices.editor.form.field.invoice_lines.column_visibility_settings.columns.total_price.both')}
        </Radio>
      </InvoiceColumnsVisibilitySettingsSection>
    </RadioGroup>
  )
}
